export function notificationTemplate (noticationAttribute) {
  if (noticationAttribute) {
    const attributeData = JSON.parse(noticationAttribute.data);
    switch (attributeData.redirection_type) {
      case 'vas_payment_success':
      case 'vas_rejected':
      case 'vas_completed':
      case 'vas_payment_failed':
      case 'vas_approved':
        return attributeData.reference_id;
      case 'order_details':
      case 'payment_success':
      case 'payment_failed':
      case 'delivered':
        return attributeData.tracking_number
      default:
        return noticationAttribute.reference_id;
    }
  }
}


/** WEBPACK FOOTER **
 ** ./src/utils/notificationTemplate.js
 **/